import { Playground } from 'docz';
import Validator from "../../../../../src/components/Validator/index";
import Input from "../../../../../src/components/Input";
import * as React from 'react';
export default {
  Playground,
  Validator,
  Input,
  React
};